import { render } from "./Chapters.vue?vue&type=template&id=051f8372&scoped=true"
import script from "./Chapters.vue?vue&type=script&lang=js"
export * from "./Chapters.vue?vue&type=script&lang=js"

import "./Chapters.vue?vue&type=style&index=0&id=051f8372&scoped=true&lang=css"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-051f8372"]])

export default __exports__